﻿import { FIQAssist } from "../app";
import { Component, Input, Output, Inject, Attribute } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'fqautosizetextarea',
    template: `<div class="fqautosizetextarea fixchild ng-class:{hasfocus:$ctrl.hasfocus,'has-value': $ctrl.hasValue, error: $ctrl.showError, readonly:$ctrl.readOnly}">
                <div class="placeholder">
                  <span class="placeholder-text unselectable" ng-hide="$ctrl.hasValue" ng-click="$ctrl.focusTextarea()">{{$ctrl.hint | translate}}</span>
                  <textarea ng-readonly="$ctrl.readOnly" class="primary" type="text" ng-model="$ctrl.value" ng-focus="$ctrl.onFocus()" ng-blur="$ctrl.onBlur()"></textarea>
                  <textarea class="hidden-area" ng-readonly="$ctrl.readOnly" style="position:absolute; left: -2000px; top:-2000px;" tabindex="-1"></textarea>
                </div>
                <span class="mandatory-dot" ng-if="$ctrl.mandatory" uib-tooltip="{{'FIELD_REQUIRED_TOOLTIP' | translate}}" tooltip-placement="bottom" tooltip-class="customTooltipTB"></span>
            </div>`
})
export class Autosize {
    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$scope') private $scope: angular.IScope
    ) {
        this.$element.on('keyup', this.adjust.bind(this));
    }
    @Input() public readOnly: boolean;

    private _mandatory;
    @Attribute() public get mandatory() {
        return this._mandatory;
    }
    public set mandatory(val: boolean | string) {
        this._mandatory = val === true || val === "true";
    }
    private get hasValue() {
        return this._value !== null && this._value !== undefined && this._value !== "";
    }
    private get showError() {
        return this.mandatory && ((!this.hasfocus && this.wasFocused && !this.hasValue) || (!this.hasfocus && this.iserror));
    }
    async $onInit() {
        var element = this.$element;
        if (this.focusinput) {
            await this.$timeout();
            (<any>(element[0].getElementsByClassName('primary').item(0))).focus();
        }
    }

    $postLink(){
        this.adjust();
    }

    adjust() {
        var element = this.$element;
        var ta1 = (<any>element[0].getElementsByClassName('primary').item(0));
        var ta2 = (<any>element[0].getElementsByClassName('hidden-area').item(0));
        (ta2 as any).value = (ta1 as any).value;
        ta2.style.width = ta1.clientWidth + "px";
        ta1.style.overflow = 'hidden';
        ta2.style.overflow = 'hidden';
        ta2.style.height = 'auto';
        ta1.style.height = (ta2.scrollHeight + this._heightCorrect) + "px";
    }

    private focusTextarea() {
        var element = this.$element;
        (<any>element[0].getElementsByClassName('primary').item(0)).focus();
    }

    private _heightCorrect:number = 0;
    @Attribute() public get heightCorrect(){
        return this._heightCorrect.toString();
    }
    public set heightCorrect(val:string){
        var h = parseInt(val,10);
        if(!isNaN(h))
            this._heightCorrect = h;
    }

    private _value: string;

    @Input() public get value(): string {
        return this._value;
    }
    public set value(val: string) {
        if (val != this._value) {
            this._value = val;
            this.onvaluechanged({ value: val });
        }
    }
    @Input() public hint: string;
    @Input() public iserror: boolean;
    @Input() public focusinput: boolean;
    @Output() public onvaluechanged: (args: { value: string }) => void;

    private hasfocus: boolean = false;
    private wasFocused: boolean = false;
    private onFocus() {
        this.hasfocus = this.wasFocused = true;
    }

    private onBlur() {
        this.hasfocus = false;
    }
}
